// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2e-q";
export var animationRelative = "_2e-p";
export var backdropBlur = "_2e-0";
export var detailLabelCell = "_2e-12";
export var detailTable = "_2e-11";
export var detailValueCell = "_2e-13";
export var docIconBox = "_2e-1d";
export var docIconBoxMd = "_2e-1f";
export var docIconBoxSm = "_2e-1e";
export var docTypeRow = "_2e-16";
export var docTypeRowInner = "_2e-17";
export var dropdownMatchDatePicker = "_2e-3";
export var evidenceCardContent = "_2e-1c";
export var fileUploadSpin = "_2e-j";
export var gorgiasOpenButton = "_2e-15 _2e-d";
export var gorgiasTicketCard = "_2e-14";
export var heroModalFooterButton = "_2e-18";
export var hiddenContainer = "_2e-o";
export var iconPrimary = "_2e-1g";
export var iconSecondary = "_2e-1h";
export var iconTertiary = "_2e-1i";
export var integrationCard = "_2e-1";
export var integrationLogoBox = "_2e-2";
export var mainColumnSticky = "_2e-1b";
export var maxWidthContainer = "_2e-19";
export var modalContentBody = "_2e-a";
export var modalHeaderImage = "_2e-5";
export var modalImageLabel = "_2e-7";
export var modalImageOverlay = "_2e-6";
export var modalImageSubtitle = "_2e-9";
export var modalImageTitle = "_2e-8";
export var modalImageWrapper = "_2e-4";
export var modalStickyFooter = "_2e-b";
export var removeButton = "_2e-e";
export var sidebarColumn = "_2e-1a";
export var spinner = "_2e-i";
export var timelineLine = "_2e-y";
export var timelineLineBlack = "_2e-10 _2e-y";
export var timelineLineGray = "_2e-z _2e-y";
export var timelineLineHeight = "_2e-x";
export var tlDotActivate = "_2e-u";
export var tlDotActivateAnim = "_2e-t";
export var tlDotHide = "_2e-s";
export var tlDotHideAnim = "_2e-r";
export var tlLineActivate = "_2e-w";
export var tlLineActivateAnim = "_2e-v";
export var uploadHint = "_2e-n";
export var uploadIconBox = "_2e-k";
export var uploadLabel = "_2e-m";
export var uploadText = "_2e-l";
export var uploadZone = "_2e-f";
export var uploadZoneCursorDefault = "_2e-h";
export var uploadZoneCursorPointer = "_2e-g";
export var uploadedFileRow = "_2e-c";
export var viewButton = "_2e-d";